import React from 'react'

import PropertyCard from '../PropertyCard'

const MapCard = props => {
  const w = 103
  const h = 36
  const offsetX = 0
  const offsetY = 60
  const th = h * 0.5
  const orgX = w * 0.5
  const orgY = h + th
  const { property } = props
  return (
    <div
      style={{
        position: 'absolute',
        top: -orgY + offsetX,
        left: -orgX + offsetY,
        transformOrigin: `${orgX} ${orgY}`,
        zIndex: 1,
      }}>
      <PropertyCard property={property} cardPlacement />
    </div>
  )
}

export default MapCard



// WEBPACK FOOTER //
// ./src/components/map/MapCard.js